import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { AppState } from "../store/configureStore";

export const RedirectIfLoggedIn = () => {
    const user = useSelector((state: AppState) => state.user);
    const login = useSelector((state: AppState) => state.login);

    if (user.token && login.loggedIn) return <Navigate to={{ pathname: "/Home" }} />;
    else return null;
};
